import { fetchPaymentGetCheckoutSession, type UrlResult } from "@crowdcoursing/api/openapi";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { assertNonEmptyString } from "~utils/assert";

import { type State } from "../state/state";

/** initiate a payment for a room
 * @deprecated We are phasing out `redux`
 */
export const onPayRoom = createAsyncThunk<
  UrlResult,
  { roomId: string; ownerId: string; amount: number },
  { state: State }
>("payments/onPayRoom", (payload, thunkAPI) => {
  const userId = thunkAPI.getState().user?.id;
  assertNonEmptyString(userId);
  return fetchPaymentGetCheckoutSession({
    body: { amount: payload.amount, recipientUserId: payload.ownerId },
    pathParams: { userId },
  });
});
